window.VH = window.VH === undefined ? {} : window.VH;
VH.PageSizer = {
    selector : false,

    init : function init(selectorId, varName) {
        let _t = VH.Sidebar;
        _t.selector = $("#" + selectorId);
        _t.selector.on('change', function () {
            let t = $(this),
                val = t.val(),
                url = t.data('url')
            ;

            $.post(url, {varName: varName, value: val}, function () {
                // Cookies.set(cookieName, val);
                document.location.reload();
            });
        });
    }
};
